import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  DocImages,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TextButton,
  TabWithContent,
  useDynamicImage
} from "../../../DocCreater";

//本文档的引用图片存放的位置
const imageFolder = "/images/learnpage/step3/";

//构件辨识实验文档
const DocPanel = props => {
  //使用动态说明图片
  const [docImageSrc1, setDocImageSrc1] = useDynamicImage(
    `${imageFolder}01-1.jpg`
  );
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}06-2.png`
  );
  return (
    <TabWithContent
      content={[
        {
          title: "实验步骤",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">实景学习模块:</Text>
                实景教学资源多为在典型的清代官式建筑现场采集的实景内容，例如建筑实地全景漫游，学生即可通过互联网在线查看建筑实景情况，以便学生通过真实建筑实物中进一步认知在清官式建筑中的各类构件的位置样式，与构件认知学习模块的理论部分相辅相成，同时为后续建筑现场踏查实习做好准备，虚实结合。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou6.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤6:</Text>
                学生点击导航栏“实景学习”栏目，进入实景学习模块，在各个实景学习模块卡片中，查看本实景资源所属的建筑实物、资源描述、资源操作方式信息，点击右下角按钮，展开实景教学资源，在资源窗口内点击全屏按钮，进行全屏模式学习获取最佳体验；实景教学资源以建筑现场实景漫游为主，可在漫游内，旋转缩放视角，切换视点，查看构件标签；实景学习资源提供扫描查看功能，学生点击右上角分享按钮，扫描弹出二维码，即可用手机查看实景学习资源，使用手机查看全景漫游类资源时，可以配合VR眼镜盒子，使用VR模式身临其境查看建筑实物；
              </Paragraph>
              <Paragraph>
                <DocLink to="/realitylearn" newpage>
                  前往实景学习页面
                </DocLink>
              </Paragraph>
            </>
          )
        },
        {
          title: "操作指南",
          detail: (
            <>
              <DocImage imageSrc={docImageSrc1} />
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-1.jpg`);
                }}
              >
                <Text color="secondary">查看资源信息:</Text>
                下方红框内即为本教学资源的名称、所属的真实建筑、资源详细信息，学习前应当先查看此信息
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-2.jpg`);
                }}
              >
                <Text color="secondary">打开资源使用窗口:</Text>
                点击红色按钮即可打开或收起资源窗口，在资源窗口可以点击本资源内的全屏按钮全屏学习
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-3.jpg`);
                }}
              >
                <Text color="secondary">资源二维码:</Text>
                点击红框内按钮可查看资源二维码，用手机扫描学习或分享
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-4.jpg`);
                }}
              >
                <Text color="secondary">修改教学资源:</Text>
                点击编辑案例信息按钮，在弹出网页中修改本教学资源的名称、所属建筑、详细信息及链接（仅教师可修改教学资源）
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc1(`${imageFolder}01-5.jpg`);
                }}
              >
                <Text color="secondary">新建教学资源:</Text>
                点击红框内按钮，在弹出网页中可新建教学资源，新建后的教学资源会在本模块添加一个新的教学资源卡片（仅教师可新建教学资源）
              </Paragraph>
            </>
          )
        },
        {
          title: "持续建设",
          detail: (
            <>
              <>
                <Paragraph>
                  实景学习模块是动态建设的模块，教师可添加、修改、删除教学资源，逐步建设完善教学资源，我们将按持续建设计划，不断建设实景教学资源内容，包括持续建设一下几类实景教学资源：
                </Paragraph>

                <Paragraph>
                  <Text color="secondary">全景漫游类资源:</Text>
                  在建筑现场实景踏查时拍摄的360度全景照片，通过软件制作为可供在线浏览的漫游资源，供学生认知建筑实物，可配合VR盒子或虚拟现实头盔进行VR沉浸式体验；
                </Paragraph>

                <Paragraph>
                  <Text color="secondary">点云类资源:</Text>
                  包括利用三维扫描仪，对建筑本体进行扫描后获得得三维扫描点云、以及建筑构件的局部手持扫描点云；
                </Paragraph>
                <Paragraph>
                  <Text color="secondary">摄影建模类资源:</Text>
                  包括利用无人机航拍及相机拍摄的照片重建的摄影建模资源，例如建筑的航空摄影建模、局部构件摄影建模模型。
                </Paragraph>
              </>
            </>
          )
        }
      ]}
    />
  );
};

function Step3(props) {
  return (
    <DocPaper>
      <Title>实景学习模块</Title>

      <DocPanel />
      <NavigateButton
        icon
        to="/learn/step/4"
        buttonText="下一步"
        iconStyle={{
          float: "right"
        }}
      />
    </DocPaper>
  );
}

export default Step3;
